import 'babel-polyfill';

import React from "react";
import ReactDOM from "react-dom";
import App from "./clientApp";
const root = document.getElementById("root");

ReactDOM.render(<App></App>, root);


// WEBPACK FOOTER //
// ./client.js